import { FC } from "react";

import { Button, ButtonProps } from "../../../ui/layout/molecules/Button";
import { Disabled } from "../../../components/Disabled";
import { Restricted } from "../../../components/Restricted";

import { AcceptableNamedRow } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import { HandleRequest } from "./types";

const handleChangeData = {
  credentials: {
    buttonTitle: "Generate new credentials",
    requestType: "API credentials",
  },
  token: {
    buttonTitle: "Generate new Read Only Token",
    requestType: "read only token",
  },
};

export const CredentialsAcceptableRow: FC<
  React.PropsWithChildren<HandleRequest>
> = ({ handleRequests }) => {
  const buttonDataByType = (
    changeType: keyof typeof handleChangeData,
  ): ButtonProps => {
    const { requestType, buttonTitle } = handleChangeData[changeType];
    return {
      buttonType: "ghost",
      title: buttonTitle,
      onClick: () => {
        return handleRequests({ requestType });
      },
    };
  };

  return (
    <AcceptableNamedRow
      title="Reset API credentials"
      permissionsGroup="site:credentials"
    >
      <div className="align-center mt-6 flex flex-col gap-2 lg:mt-8">
        <Disabled editPermissions="site:credentials:update">
          <Button {...buttonDataByType("credentials")} />
        </Disabled>
        <Restricted permissions="site:readonly_token:update">
          <Button {...buttonDataByType("token")} />
        </Restricted>
      </div>
    </AcceptableNamedRow>
  );
};
